/**
 * Author: Abhishek Lamrood
 * 
 * This is generic component for displaying a grid for last 5 transactions. you can rename this component to search-transactions.
 * This component works on the configuration json, where we configure the data for differenct transactionStates/serviceTasks
 * To integrate search-configurations Component you need to have below input and output properties:
 * To use this component create a module, import this component in that module and load that module to render this component
 *  @Input() transactionState = null;
    @Input() configData;
 * 
 * Example:
 * <search-configuration [configData]="configData" [transactionState]="transactionState"></search-configuration>
 * 
 * Configurations Required in JSON file
 * "TransactionDetailsMetaData": {
 *   "product": {
            "buttonName": "New Product",
            "title": "New Product",
            "searchCriteria": "searchProduct",
            "breadCrumb": "Product",
            "searchURL": "api/product/searchProduct",
            "itemsPerPage": 100,
            "methodType": "post",
            "tableHeading": "Configured Products",
            "externalParams": [
                {
                    "paramName": "planTypeCd",
                    "paramValue": "BASEPLAN"
                }
            ],
            "searchTableHeaders": [
                {
                    "header": "Product Name",
                    "key": "ProductName",
                    "pipe": null,
                    "searchFilter": true,
                    "sortFilter": true,
                    "isVisible": true
                },
                {
                    "header": "Product Family",
                    "key": "productFamilyCd",
                    "pipe": "technicalTranslate",
                    "searchFilter": true,
                    "sortFilter": false,
                    "isVisible": true
                },
                {
                    "header": "Product Type",
                    "key": "productTypeCd",
                    "pipe": "technicalTranslate",
                    "searchFilter": true,
                    "sortFilter": false,
                    "isVisible": true
                },
                {
                    "header": "Product Status",
                    "key": "productStatus",
                    "pipe": "technicalTranslate",
                    "searchFilter": true,
                    "sortFilter": false,
                    "isVisible": true
                }
            ],
            "fetchUrl1": "api/product/v2/fetch-by-guid/",
            "nestedAPICall": false,
            "id1": "guid",
            "dataCominginIO": true
        }
 * }
 * 
**/

// import { MetadataService } from '../../../../BaseFramework/core/http/metadata.service';
import { Component, OnInit, Input, Output, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router'
import * as moment from 'moment/moment';
import { Observable, ReplaySubject, Subject, forkJoin, zip, of, pipe, BehaviorSubject } from 'rxjs';
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import {
    InteractService, ApiRequestService, UserInfoService, AppMetadataHandler, CommonUtilty, SearchCriteriaDO
} from 'app'
import { environment } from 'environments/environment';
import { TechnicalTranslatePipe } from 'app/BaseFramework/shared/custom-pipes/technicalTranslate/technical-translate.pipe';
import { MetadataService } from '../../../BaseFramework/core/http/metadata.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import * as XLSX from 'xlsx';
import { DatePipe } from '@angular/common';
import { DataTransformService } from 'app/ViewModules/shared-services/data-transform/data-transform.service';
import data from './configurator-transaction-details.json'

class SearchAPIMetaDataDO {
    key: any;
    keyDescription: any;
    valueInputType: any;
    lookupName: any;
    lookup: any;
    enable: any;
    isMandatory: Boolean;
}

@Component({
    selector: 'search-configuration',
    templateUrl: './search-configuration.component.html',
    styleUrls: ['./search-configuration.component.scss'],
    providers: [TechnicalTranslatePipe, DatePipe]
})
export class SearchConfigurationComponent implements OnInit {

    public CRITERIALOOKUP = [];
    public dataSet = [];
    public intimationType = null
    public viewType = null
    public searchConfigurationZeroState = {
        title: "Search Required",
        message: "Hit search to view results",
        icon: "file-search"
    }
    public companyDetails: any
    public companyBranchDO: any
    searchValue: null;
    headingPrefix = ""
    refreshComponentToggle = true;
    isUserPrivileged = false;
    isHKUserPrivileged = false;
    ruleAuditModal = false;
    viewRuleArr: any = [];
    viewAuditRuleArr: any = [];
    userRoleList:any;

    filterParams = {
        comparator: function (filterLocalDateAtMidnight: Date, cellValue: string) {
            var dateAsString = cellValue;
            if (dateAsString == null) return -1;
            var dateParts = dateAsString.split('/');
            var cellDate = new Date(
                Number(dateParts[2]),
                Number(dateParts[1]) - 1,
                Number(dateParts[0])
            );
            if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
                return 0;
            }
            if (cellDate < filterLocalDateAtMidnight) {
                return -1;
            }
            if (cellDate > filterLocalDateAtMidnight) {
                return 1;
            }
        },
        browserDatePicker: true,
        minValidYear: 2000,
        maxValidYear: 2021,
    };


    @Input() mode: 'drawer'
    @Input() transactionState = null;
    configData = data

    constructor(private router: Router,
        private interactService: InteractService,
        private userInfoService: UserInfoService,
        private apiRequestService: ApiRequestService,
        private activatedRoute: ActivatedRoute,
        private commonUtilty: CommonUtilty,
        private technicalTranslatePipe: TechnicalTranslatePipe,
        public appMetadataHandler: AppMetadataHandler,
        public message: NzMessageService,
        public metadataService: MetadataService,
        private route: ActivatedRoute,
        private dataTransformService: DataTransformService,
        private datePipe: DatePipe) { }

    searchVocabularyForm: FormGroup
    SEARCHVOCABULARYFORMNAME = "searchVocabularyForm"
    pathFromRoot = [];
    searchResultsList = [];
    filterKey = null;

    lookupsToBind = ['vocabParentObj', 'vocabSubObj', 'vocabChildObj', 'vocabUiType', 'comboName', 'serviceObject', 'vocabDataTypeCd',
        'vocabGrandChildObj', 'vocabComputedByCd', 'aggrFunOperatorsCd', 'aggregateFunctionsCd', 'productFamilyCd',
        'vocabType', 'comboName']

    lookup$ = this.commonUtilty.initializeLookupList(this.lookupsToBind)

    //configPath = environment.configPath;
    payloadInEdit
    item
    env = environment

    vocabularyDetails: any = {};
    transactionModal = false;
    intimationSourceCd = null;
    extraExternalParams = [];


    /* AG Grid Variables */
    private _columnDefs: any[] = [];
    public get columnDefs(): any[] {
        return this._columnDefs;
    }
    public set columnDefs(value: any[]) {
        this._columnDefs = this.convertLegacyConfigToNew(value['searchTableHeaders']) || value['grid-columns-defs'];
    }
    rowData: []
    gridAPI: any;
    columnAPI: any;
    eGridDiv
    paginationPageSize = 0
    rowSelection
    searchDataIsInProcess : boolean = false;

    ngOnInit() {
        this.activatedRoute.data.subscribe(data => {
            this.extractTransactionFromPath();
          });
        let parameter = this.route.snapshot.paramMap.get("ruleName");
        this.extraExternalParams = this.configData.TransactionDetailsMetaData[this.transactionState].externalParams ? this.configData.TransactionDetailsMetaData[this.transactionState].externalParams : [];
        this.dataTransformService.gridTransactionState = this.transactionState;
        this.columnDefs = this.configData.TransactionDetailsMetaData[this.transactionState];
        
        if (parameter) {
            this.intimationSourceCd = parameter
            this.transactionState = 'rule'
            this.openNewTransaction()
        } else {
            this.fetchConfigurations();
            this.getSearchCriteriaList()
        }

        this.getMakerCheckerPrivileges();
        // this.getHKPrivileges();
        // if you want pass extra params for fetching result, put our extra params in the configuration
        console.log("user info", this.userInfoService.getUserInfo())

    }

    extractTransactionFromPath() {

        // if (this.commonUtilty.isArrayIterable(this.activatedRoute.pathFromRoot)) {
        //   this.activatedRoute.pathFromRoot.forEach(item => {
        //     if (item.routeConfig && item.routeConfig.path)
        //       this.pathFromRoot.push(item.routeConfig.path);
        //   })
        //   this.transactionState = this.commonUtilty.isArrayIterable(this.pathFromRoot) ? this.pathFromRoot[2] : null;
        //   console.log("transactionState", this.transactionState);
        // }
        this.transactionState = 'search-config'
      }

    fetchSearchResult($event) {
        console.log("123");
        if ($event && !$event.reset) {
            if ($event && $event.results) {
                this.dataSet = $event.results;
            } else if (!$event.results) {
                let resultKey = this.configData.StateToDOMapper[this.transactionState];
                if (resultKey) this.dataSet = $event[resultKey];
            }
            console.log(this.dataSet)
            if (!this.dataSet || (this.dataSet && this.dataSet.length == 0)) {
                this.searchResultsList = [];
                this.headingPrefix = "Search Result: "
                this.searchConfigurationZeroState.title = "No Results found"
                this.searchConfigurationZeroState.message = "No records available for the selected search criteria."
            } else {
                this.headingPrefix = "Search Result: "
                this.searchResultsList = this.dataSet;
                this.searchResultsList = this.transformValues(this.searchResultsList);
                this.rowData = this.commonUtilty.deepCopy(this.searchResultsList);
            }
        } else {
            this.fetchConfigurations();
        }
    }

    private transformValues(list) {
        if (this.commonUtilty.isArrayIterable(list)) {
            list.forEach((row: any) => {
                let searchResultKeys = Object.keys(row);
                if (this.commonUtilty.isArrayIterable(searchResultKeys)) {
                    if (this.commonUtilty.isArrayIterable(this.columnDefs)) {
                        this.columnDefs.forEach(config => {
                            if (searchResultKeys.includes(config.field) && (config['pipe'] && config['pipe'] == 'technicalTranslate')) {
                                row[config.field] = this.technicalTranslatePipe.transform(row[config.field], config['pipeValue']);
                            }
                            if (config['pipe'] && config['pipe'] == 'date') {
                                if (row[config.field] && Array.isArray(row[config.field])) {
                                    row[config.field] = this.commonUtilty.serverDOtoUIDODate(row[config.field]);
                                }

                                if (row[config.field])
                                    row[config.field] = this.datePipe.transform(row[config.field], this.appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR);
                            }

                        });
                    }
                }

            });
        }
        return list;
    }

    lastCheckboxPendingToBeUnticked() {
        return this.columnDefs.filter(e => e['isVisible']).length == 1
    }

    getDateString(rawDate) {
        let dateString
        if (rawDate != null) {
            dateString = moment(rawDate).format(this.appMetadataHandler.GLOBAL_DATE_FORMAT_MOMENT);
        }
        else {
            dateString = 'N/A'
        }
        return dateString
    }

    /* Filter varaibles */

    ruleName
    productName

    //Reopen claimsre
    vocabModel = false;
    reopenComment = null;
    reportFooter = true
    _reopenInProgress = false
    IO: any = {};



    vacMappingDataSet = [];
    openTransactionModal(data?) {
        this.transactionModal = true
    }

    closeTransactionModal() {
        this.transactionModal = false
    }
    openNewTransaction() {
        const messageId = this.message.loading('Fetching data...', { nzDuration: 0 }).messageId;
        this.message.remove(messageId);
        let data = {
           'workflowDO':{ 
            "companyName": 'Manulife Insurance Ltd',
            "workflowName": null,
            "applicationID": null,
            "updatedBy": 'contact@manulife.com',
            "statusCd": 'Draft',
            'flowChartJSON': {
              "root": {
              }
          }
        }
          }
        this.interactService.openNewTransaction(this.transactionState, null, this.intimationSourceCd, data)
    }
    /* fetchUrl1  - URL for first call
       fetchUrl2  - URL for second call
       nestedAPICall - Flag check if there is multiple API call
       id1 - id that is needed for fetchCall1 (may vary on different pages)
       id2 - id that is needed for fetchCall2 (may vary on different pages)
       dataCominginIO - flag check if data is coming in IO
       IOStructure - Structure of IO if IO is missing from API

    */

    editTransaction(userData, privilege?) {
        // if (userData && userData.workflowStatusCd == 'PUBLISH') privilege = 'VIEW';
        const messageId = this.message.loading('Fetching data...', { nzDuration: 2000 }).messageId
        if (this.transactionState == 'remarkMapping') {
            let searchCriteriaItem = {};
            if (userData.remarkTypeCd && userData.productCd) {
                searchCriteriaItem = {
                    searchCriteriaList: [{ "paramName": "typeCd", "paramValue": userData.remarkTypeCd },
                    { "paramName": "productCd", "paramValue": userData.productCd }]
                };
            }
            else if (userData.remarkTypeCd && !userData.productCd) {
                searchCriteriaItem = { searchCriteriaList: [{ "paramName": "typeCd", "paramValue": userData.remarkTypeCd }] };
            }
            else if (!userData.remarkTypeCd && userData.productCd) {
                searchCriteriaItem = { searchCriteriaList: [{ "paramName": "productCd", "paramValue": userData.productCd }] };
            }
            this.apiRequestService.post('corresRemarks/map/fetch', searchCriteriaItem).subscribe(resp => {
                if (resp && Object.entries(resp).length > 0 && !resp['errormesage']) {
                    this.interactService.openNewTransaction(this.transactionState, resp, privilege)
                } else this.message.error('Server Error: Could not fetch the selected data. Please contact administrator')
            }, error => {
                this.message.error('Server Error: Could not fetch the selected data. Please contact administrator')
            })
        }
        else {
            if (this.configData.TransactionDetailsMetaData[this.transactionState]) {
                if (this.configData.TransactionDetailsMetaData[this.transactionState].fetchUrl1) {
                    if (this.configData.TransactionDetailsMetaData[this.transactionState].nestedAPICall) {
                        this.message.remove(messageId);
                        this.apiRequestService.get(this.configData.TransactionDetailsMetaData[this.transactionState].fetchUrl1 + userData[this.configData.TransactionDetailsMetaData[this.transactionState].id1]).subscribe(value => {
                            if (value && Object.entries(value).length > 0 && !value['errormesage']) {

                                this.apiRequestService.get(this.configData.TransactionDetailsMetaData[this.transactionState].fetchUrl2 + userData[this.configData.TransactionDetailsMetaData[this.transactionState].id2]).subscribe(resp => {
                                    if (resp && Object.entries(resp).length > 0 && !resp['errormesage']) {
                                        if (this.configData.TransactionDetailsMetaData[this.transactionState].dataCominginIO && value)
                                            this.interactService.openNewTransaction(this.transactionState, value, privilege)
                                        else if (!this.configData.TransactionDetailsMetaData[this.transactionState].dataCominginIO && value && resp) {
                                            let data = this.configData.TransactionDetailsMetaData[this.transactionState].IOStructure
                                            let keys = Object.keys(this.configData.TransactionDetailsMetaData[this.transactionState].IOStructure)
                                            data[keys[0]] = resp
                                            data[keys[1]] = value
                                            this.interactService.openNewTransaction(this.transactionState, data, privilege)
                                        }
                                        else {
                                            this.message.error('Server Error: Could not fetch the selected data. Please contact administrator')
                                        }
                                    } else this.message.error('Server Error: Could not fetch the selected data. Please contact administrator')
                                }, error => {
                                    this.message.error('Server Error: Could not fetch the selected data. Please contact administrator')
                                })
                            } else this.message.error('Server Error: Could not fetch the selected data. Please contact administrator')
                        }, error => {
                            this.message.error('Server Error: Could not fetch the selected data. Please contact administrator')
                        })
                    }
                    else {
                        this.apiRequestService.get(this.configData.TransactionDetailsMetaData[this.transactionState].fetchUrl1 + userData[this.configData.TransactionDetailsMetaData[this.transactionState].id1]).subscribe(value => {
                            if (value && Object.entries(value).length > 0 && !value['errormesage']) {
                                this.message.remove(messageId);
                                if (this.configData.TransactionDetailsMetaData[this.transactionState].dataCominginIO && value)
                                    this.interactService.openNewTransaction(this.transactionState, value, privilege)
                                else if (!this.configData.TransactionDetailsMetaData[this.transactionState].dataCominginIO && value) {
                                    let data = this.configData.TransactionDetailsMetaData[this.transactionState].IOStructure
                                    let keys = Object.keys(this.configData.TransactionDetailsMetaData[this.transactionState].IOStructure)
                                    data[keys[0]] = value
                                    this.interactService.openNewTransaction(this.transactionState, data, privilege)
                                }
                                else {
                                    this.message.error('Server Error: Could not fetch the selected data. Please contact administrator')
                                }
                            } else this.message.error('Server Error: Could not fetch the selected data. Please contact administrator')
                        }, error => {
                            this.message.error('Server Error: Could not fetch the selected data. Please contact administrator')
                        })
                    }
                }
                else {
                    this.message.remove(messageId);
                    if (this.configData.TransactionDetailsMetaData[this.transactionState].dataCominginIO)
                        this.interactService.openNewTransaction(this.transactionState, userData, privilege)
                    else {
                        let dataFl = this.configData.TransactionDetailsMetaData[this.transactionState].IOStructure
                        if(dataFl){
                        let workflowDO = {
                            workflowDO:userData
                        }
                        this.interactService.openNewTransaction(this.transactionState, null, null, workflowDO)
                        }
                    }
                }
            }
        }
    }



    itemsPerPage: any = 5;
    currentPage: any = 5;
    //searchURL = "claim/Intimation/search"
    searchSYSVOCAB = "master/vocabulary/fetchAllVocabularyNameOnVCPage/SYSTEM"
    searchUSERVOCAB = "master/vocabulary/fetchAllVocabularyNameOnVCPage/USER"
    urlArray = [this.searchSYSVOCAB, this.searchUSERVOCAB];
    getSystemVocabulary() {
        // this.apiRequestService.get(this.searchSYSVOCAB).subscribe(data => {
        //   this.dataSet = data;
        // });

        this.message.loading('Fetching data...', { nzDuration: 2000 });
        let observables = new Array();
        let VocSubject: ReplaySubject<any> = new ReplaySubject<any>(1);
        for (let i = 0; i < this.urlArray.length; i++) {
            observables.push(this.apiRequestService.get(this.urlArray[i]));
        }

        forkJoin(observables).subscribe((res) => {
            let response: any[] = res;
            this.manupulateVocabulary(response)
        })
    }
  
    manupulateVocabulary(response) {
        let sysVocab = []
        let userVocab = []
        sysVocab.push(...response[0])
        userVocab.push(...response[1])

        sysVocab.forEach(element => {
            let productFamilyCode = this.commonUtilty.convertCSVToArray(element.productFamilyCSV);
            let lowCaseProuctFamilyCode = [];
            productFamilyCode.forEach(code => {
                // lowCaseProuctFamilyCode.push(code.toLocaleLowerCase());
                lowCaseProuctFamilyCode.push(this.technicalTranslatePipe.transform(code));

            });
            element.productFamilyCSV = this.commonUtilty.convertArrayToCSV(lowCaseProuctFamilyCode);
            this.dataSet.push(element)
        });
        userVocab.forEach(element => {
            let productFamilyCode = this.commonUtilty.convertCSVToArray(element.productFamilyCSV);
            let lowCaseProuctFamilyCode = []
            productFamilyCode.forEach(code => {
                //lowCaseProuctFamilyCode.push(code.toLocaleLowerCase());
                lowCaseProuctFamilyCode.push(this.technicalTranslatePipe.transform(code));
            });
            element.productFamilyCSV = this.commonUtilty.convertArrayToCSV(lowCaseProuctFamilyCode);
            this.dataSet.push(element)
        });
    }

    tracePanel = false;
    traceDataSet = []
    ruleDataSet = []
    productDataSet = []
    traceDepURL = "master/vocabulary/traceDependency/"
    //vocabularyCd: "AdminCharges"

    saveVocabulary() {
        console.log(this.vocabularyDetails)
    }
    approveVocabulary() {
        console.log("Approve vocab working on it");
    }


    fetchConfigurations() {
        this.message.loading('Fetching data...', { nzDuration: 2000 });
        console.log("config data", JSON.stringify(this.configData));
        console.log("transactionState", JSON.stringify(this.transactionState));
        if (this.transactionState && this.configData && this.transactionState != "cacheClean") {
            this.searchDataIsInProcess = true;
            let url = this.configData['TransactionDetailsMetaData'][this.transactionState].searchURL;
            this.itemsPerPage = this.configData['TransactionDetailsMetaData'][this.transactionState].defaultSearchResultItemsPerPage || 5;
            var payload = {}
            payload["size"] = this.itemsPerPage;
            payload["searchCriteriaList"] = []
            var criteriaItem = {}
            if (this.commonUtilty.isArrayIterable(this.extraExternalParams)) {
                payload["searchCriteriaList"] = this.commonUtilty.deepCopy(this.extraExternalParams);
            }
            let methodType = this.configData['TransactionDetailsMetaData'][this.transactionState].methodType;
            this.apiCall(methodType, url, payload).subscribe(resp => {
                console.log("data response", JSON.stringify(resp));
                let resultKey = this.configData.StateToDOMapper[this.transactionState];
                // temp code
                let searchableWorkflowArray = [] 
                this.interactService.workflowList.forEach(res=>{
                    searchableWorkflowArray.push(res['workflowDO'])
                })
                this.searchResultsList = searchableWorkflowArray
                this.searchResultsList = this.transformValues(this.searchResultsList);
                this.dataSet = this.searchResultsList;
                this.rowData = this.commonUtilty.deepCopy(this.searchResultsList);
                this.searchDataIsInProcess = false;
            })
        }
    }

    convertLegacyConfigToNew(legacyConfig){
        let newConfigFromGridLegacyConfig;
        if(this.commonUtilty.isArrayIterable(legacyConfig)){
            newConfigFromGridLegacyConfig = legacyConfig.map(config=>{
                return {
                    ...config,
                    headerName:config.header,
                    field: config.key,
                    filter: config.searchFilter,
                    sortable: config.sortFilter,
                    cellRenderer: null
                }
            })
        }
        return newConfigFromGridLegacyConfig;
    }

    private renderAgGrid() {
        if (this.commonUtilty.isArrayIterable(this.rowData)) {
            this.rowData.forEach((row: any) => {
                let searchResultKeys = Object.keys(row);
                if (this.commonUtilty.isArrayIterable(searchResultKeys)) {
                    if (this.commonUtilty.isArrayIterable(this.columnDefs)) {
                        this.columnDefs.forEach(config => {
                            if (searchResultKeys.includes(config.field)) {
                                if (config['pipe'] && config['pipe'] == 'technicalTranslate') {
                                    row[config.field] = this.technicalTranslatePipe.transform(row[config.field], config['pipeValue']);
                                }
                                if (config['pipe'] && config['pipe'] == 'date') {
                                    row[config.field] = this.datePipe.transform(row[config.field], this.appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR);
                                }

                                if (!row[config.field]) {
                                    row[config.field] = "No data found";
                                    // config['cellClass'] = "nodatafound";
                                } 
                                // else {
                                //     config['cellClass'] = "";
                                // }
                            }
                        });
                    }
                }
            });
        }
    }


    apiCall(methodType, url, payload?): Observable<any> {
        if (methodType == 'get' && payload)
            return this.apiRequestService[methodType](url);
        else if (methodType == 'post')
            return this.apiRequestService[methodType](url, payload);
    }

    getSearchCriteriaList() {
        if (this.configData) {
            this.metadataService.fetchAPIMetaData(this.configData['TransactionDetailsMetaData'][this.transactionState].searchCriteria)
                .subscribe(jsonResp => {
                    if (jsonResp && Array.isArray(jsonResp)) {
                        jsonResp.forEach(criteria => {
                            let searchCriteriaDO = new SearchAPIMetaDataDO();
                            searchCriteriaDO.key = criteria.attributeName;
                            searchCriteriaDO.keyDescription = criteria.description;
                            searchCriteriaDO.valueInputType = criteria.attributeDataTypeCd;
                            searchCriteriaDO.lookupName = criteria.attributeLookupCd;
                            searchCriteriaDO.lookup = [];
                            searchCriteriaDO.enable = true;
                            searchCriteriaDO.isMandatory = criteria.mandatoryFl == 'YES' ? true : false;
                            // if (criteria.description == 'Template Name') searchCriteriaDO.key = '';
                            this.CRITERIALOOKUP.sort();
                            this.CRITERIALOOKUP.push(searchCriteriaDO)
                        })
                    }
                })
        }

    }

    searchConfiguration(value) {
        if (value) {
            this.searchResultsList = this.dataSet.filter(item => item[this.filterKey] ? item[this.filterKey].toLowerCase().includes(value.toLowerCase()) : [])
            this.searchValue = null;
        }
    }

    getSelectedCriteria(criteria) {
        if (criteria.selectedCriteriaKey === 'planTypeCd') {
            let criteria = { paramName: 'planTypeCd', paramValue: 'TEMPLATE' };
            this.extraExternalParams = this.commonUtilty.uniquePushInArray(this.extraExternalParams, criteria, 'paramName')
        } else {
            if (this.transactionState == 'product') {
                let basePlanCriteria = { paramName: 'planTypeCd', paramValue: 'BASEPLAN' };
                this.extraExternalParams = this.commonUtilty.uniquePushInArray(this.extraExternalParams, basePlanCriteria, 'paramName');
            }
        }



        // if (criteria.selectedCriteriaKey === 'planTypeCd') {
        //     if (this.configData.TransactionDetailsMetaData['product'].externalParams) {
        //         let foundParamIndex = this.configData.TransactionDetailsMetaData['product'].externalParams.findIndex(item => item.paramName == 'planTypeCd');
        //         if (foundParamIndex != -1) this.configData.TransactionDetailsMetaData['product'].externalParams[foundParamIndex].paramValue = 'TEMPLATE'
        //         // let templateCriteria = { paramName: 'templateFl', paramValue: 'true' };
        //         // this.configData.TransactionDetailsMetaData['product'].externalParams = this.commonUtilty.uniquePushInArray(this.configData.TransactionDetailsMetaData['product'].externalParams, templateCriteria, 'paramName');
        //     }
        // } else {
        //     let basePlanCriteria = { paramName: 'planTypeCd', paramValue: 'BASEPLAN' };
        //     this.configData.TransactionDetailsMetaData['product'].externalParams = this.commonUtilty.uniquePushInArray(this.configData.TransactionDetailsMetaData['product'].externalParams, basePlanCriteria, 'paramName');
        // }
        console.log("selectedCriteria", criteria);
    }

    reset(): void {
        this.searchValue = null;
        this.searchResultsList = this.dataSet;
    }

    filterMenuVisibilityChanged(event) {
        this.searchValue = null;
    }

    getConfigKey(key) {
        this.filterKey = key;
        console.log("config key", key);
    }

    sortName: string | null = null;
    sortValue: string | null = null;

    sort(sort: { key: string; value: string }): void {
        this.sortName = sort.key;
        this.sortValue = sort.value;

        if (this.sortName && this.sortValue) {
            let orderBy = this.sortValue === 'ascend' ? 'asc' : 'desc';
            this.searchResultsList = this.commonUtilty.deepCopy(this.commonUtilty.sortObject(this.sortName, this.searchResultsList, orderBy))
        } else {
            this.searchResultsList = this.dataSet;
        }
        console.log("sorted searchResultsList", JSON.stringify(this.searchResultsList));
    }

    private _toggleRefreshComponent() {
        this.refreshComponentToggle = false;
        setTimeout(() => { this.refreshComponentToggle = true; }, 300);
    }

    clearCache() {
        this.apiRequestService.getCallWithAPIMapper("clearCache").subscribe(() => {
            this.message.success('Cache Cleared Successfully', { nzDuration: 2000 });
        })
    }

    manageHeaders(data) {
        console.log("manager headers data", JSON.stringify(data));
    }

    selectedRuleData = null;
    showRuleAuditData(ruleData) {
        this.selectedRuleData = ruleData;
        this.ruleAuditModal = true;
    }

    ruleMode = null;
    viewRule(data, ruleType) {
        this.ruleMode = ruleType;
        let groupedResponse: any = [];
        if (ruleType == 'viewRule') {
            let pathVariables = [];
            pathVariables.push(data.ruleName);
            let getRuleName = this.apiRequestService.getCallWithAPIMapper('fetchByRuleName', null, null, pathVariables)
            groupedResponse.push(getRuleName);
        }
        if (ruleType == 'viewRuleAudit') {
            let pathVariables = [];
            pathVariables.push(data.ruleName);
            let getRuleName = this.apiRequestService.getCallWithAPIMapper('fetchByRuleName', null, null, pathVariables)
            groupedResponse.push(getRuleName);
            let getAuditRule = this.apiRequestService.getCallWithAPIMapper('auditFetchByEntityCode', null, null, pathVariables)
            groupedResponse.push(getAuditRule);
        }

        zip(...groupedResponse)
            .subscribe(fetchAll => {
                console.log("view rule all responses", JSON.stringify(fetchAll));
                if (fetchAll && fetchAll.length) {
                    this.ruleAuditModal = true;
                    this.viewRuleArr = fetchAll[0];
                    if (ruleType == 'viewRuleAudit') {
                        this.viewAuditRuleArr = fetchAll[1];
                    } else {
                        this.viewAuditRuleArr = [];
                    }
                }
                // console.log(this.viewRuleArr)
                // console.log(this.viewAuditRuleArr)
            })
    }


    /*Rule Testing Modal Functionality*/
    showRuleTestingModal: boolean = false;
    openRuleTestingModal() {
        this.showRuleTestingModal = true;
    }

    closeRuleTestingModal() {
        this.showRuleTestingModal = false;
    }
    /*End of Rule Testing Modal Functionality*/

    //Template Downloader
    createTemplateExcel() {
        let wb = XLSX.utils.book_new();
        let searchHeader = this.columnDefs.map(headerConfig => headerConfig['header']);
        let searchData = this.searchResultsList.map(data => {
            let mappedData = [];
            this.columnDefs.forEach(headerConfig => {
                if (!headerConfig.pipe) {
                    mappedData.push(data[headerConfig.field]);
                }
                else if (headerConfig.pipe && headerConfig.pipe == 'technicalTranslate') {
                    // mappedData.push((headerConfig.key == 'vocabularyType' && data[headerConfig.key] === 'SYSTEM') ? 'System' : (this.technicalTranslatePipe.transform(data[headerConfig.key])));
                }
                // else if (this.searchResultsList[headerConfig.key] && headerConfig.pipe && headerConfig.pipe == 'date') {
                //     mappedData.push(this.dateTransform.transform(this.searchResultsList[headerConfig.key], this.appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR, 'GMT'));
                // }
                else if (!this.searchResultsList[headerConfig.field]) {
                    mappedData.push("-");
                }
            });
            return mappedData;
        })

        let templateHeaders = searchHeader;
        let templateFileName = this.configData.TransactionDetailsMetaData[this.transactionState].tableHeading;
        wb.Props = {
            Title: templateFileName,
            Subject: "Insurance",
            Author: "MetaMorphoSys",
            CreatedDate: new Date()
        };
        wb.SheetNames.push(templateFileName);
        let ws_data = [[...templateHeaders], ...searchData];
        let ws = XLSX.utils.aoa_to_sheet(ws_data);
        wb.Sheets[templateFileName] = ws;
        let wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });
        let xlFile = new Blob([this.sheetToArrayBuffer(wbout)], { type: "application/octet-stream" });
        this.downloadExcelFile(xlFile, `${templateFileName}.xlsx`);
    }

    sheetToArrayBuffer(wbout) {
        let buf = new ArrayBuffer(wbout.length); //convert s to arrayBuffer
        let view = new Uint8Array(buf);  //create uint8array as viewer
        for (let i = 0; i < wbout.length; i++) view[i] = wbout.charCodeAt(i) & 0xFF; //convert to octet
        return buf;
    }

    downloadExcelFile(blob: any, filename: string): boolean {
        if (!filename) filename = 'file.xlsx';
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.setAttribute('style', 'display:none;');
        document.body.appendChild(a);
        a.href = url;
        a.download = filename;
        a.target = "_blank";
        a.click();
        URL.revokeObjectURL(a.href);
        return true;//url;
    }

    getMakerCheckerPrivileges(){
        let userInfo = this.userInfoService.getUserInfo()
        if (userInfo && userInfo.userRoleCdCSV)
            this.isUserPrivileged = userInfo.userRoleCdCSV.includes('MAKER');
    }

    typeOf(value) {
        return typeof value;
      }
}
